const en = {
  "joinNow": {
    "who_are_you": {
      "pageTitle": "Join Now",
      "title": "Who are you? We’d like to know you better.",
      "option": ['Creator', 'Investor', 'Artist'],
      "nextButton": 'Next'
    },
    "create_new_account": {
      "pageTitle": "Create a new account.",
      "titleA": "Come join our community! Let’s set up your account.",
      "titleB":"Already have one?",
      "signinButton":"Sign In here.",
      "lastText": "By submitting the form, you agree to our",
      "termsOfService": "Terms of service.",
      "nextButton": "Next",
      "OR": "OR",
      "form": {
        "email": "Email*",
        "companyEmail": "Company Email*",
        "password": "Password*",
        "name": "Full Name*",
        "userType": "Select user type",
        "country": "Location*",
        "companyName": "Company Name*",
        "companyAddress": "Company Address*",
        "typeOptions": ["Individual Investor", "Organization"],
        "role": "Creator's role",

      }
    },

  },
  "tagsView": {
    "project": {
      "pageTitle": "What kind of projects are you interested in?",
      "title": "This will allow us to show you the best matches for your interests.",
      "tags":{
        'TV Drama': 'TV Drama',
        'Animations': 'Animations',
        'Other': 'Other',
        'Indie Shorts': 'Indie Shorts',
        'Feature Films': 'Feature Films',
        'Documentaries': 'Documentaries',
        'Anime':'Anime'
      }
    },
    "geography": {
      "pageTitle": "What geographies are you interested to finance in?",
      "title": "This will allow us to show you the best matches for your interests.",
      "tags":{
        'United Kingdom': 'United Kingdom',
        'India': 'India',
        'Nigeria': 'Nigeria',
        'Europe':  'Europe',
        'China': 'China',
        'South Korea': 'South Korea',
        'United States':  'United States',
        'Other': 'Other'
      }
    },
    "nextButton": "Next",
    "backButton": "Back",
    "label": "Tags"
  }
}



module.exports = en;